<script>
import { FormItem } from 'element-ui'
import { mapGetters } from 'vuex'
export default {
	extends: FormItem,
	name: 'ElFormItem',
	computed: {
		...mapGetters(['language']),
		contentStyle() {
			const ret = {}
			const label = this.label
			if (this.form.labelPosition === 'top' || this.form.inline) return ret
			if (!label && !this.labelWidth && this.isNested) return ret
			const labelWidth = this.labelWidth || this.form.labelWidth
			if (labelWidth === 'auto') {
				if (this.labelWidth === 'auto') {
					if (this.language === 'ar') {
						ret.marginRight = this.computedLabelWidth
					} else {
						ret.marginLeft = this.computedLabelWidth
					}
				} else if (this.form.labelWidth === 'auto') {
					if (this.language === 'ar') {
						ret.marginRight = this.elForm.autoLabelWidth
					} else {
						ret.marginLeft = this.elForm.autoLabelWidth
					}
				}
			} else {
				if (this.language === 'ar') {
					ret.marginRight = labelWidth
				} else {
					ret.marginLeft = labelWidth
				}
			}
			return ret
		}
	}
}
</script>
